function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * @file 转换 object 为 query string 形式
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/json
 */

/**
 * 将字符串解释为对象
 *
 * @function
 * @param {string} string 要解释的字符串
 * @return {Object} 解释后的对象
 */
export var parse = function parse(string) {
  // 首字符为 "{" 或 "[" 时，按 JSON.stringify 后的字符串解释
  if (/^[\[\{]/.test(string)) {
    try {
      return new Function("return (".concat(string, ")"))();
    } catch (e) {
      return {};
    }
  }
  return string.split(/&/).reduce(function (json, equalment) {
    var _equalment$split = equalment.split('='),
      _equalment$split2 = _slicedToArray(_equalment$split, 2),
      key = _equalment$split2[0],
      value = _equalment$split2[1];
    if (value != null) {
      json[key] = value;
    }
    return json;
  }, {});
};

/**
 * 处理数据项的值，对于函数类型自动执行
 *
 * @param {*} value 评估的数据值
 * @return {*} 评估处理后的数据值
 */
var evaluate = function evaluate(value) {
  return typeof value === 'function' ? value() : value;
};

/**
 * 转换对象为 URL 参数
 *
 * @function
 * @param {Object|string} json 要转换的对象
 * @return {string} 转换后的字符串
 */
export var toQuery = function toQuery() {
  var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return typeof json === 'string' ? json : Object.keys(json).reduce(function (result, key) {
    var value = evaluate(json[key]);
    // TODO: 2019 排期，后端处理好不传的 key 为 null 后，可以恢复对空值的一报优化
    if (value != null) {
      result.push("".concat(key, "=").concat(encodeURIComponent(value)));
    }
    return result;
  }, []).join('&');
};
var isObject = function isObject(input) {
  return Object.prototype.toString.call(input) === '[object Object]';
};

/**
 * 复制目标对象字段到源对象（浅复制）
 *
 * @function
 * @param {Object} source 源对象
 * @param {?Object} target 目标对象
 * @return {Object} 源对象
 */
export var extend = function extend(source) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  var count = args.length;
  if (!count) {
    return source;
  }
  var _loop = function _loop() {
    var item = _args[_i2];
    if (item == null || !isObject(item)) {
      return "continue";
    }
    Object.keys(item).reduce(function (result, key) {
      result[key] = isObject(item[key]) ? extend({}, result[key], camelToUnder(item[key])) : item[key];
      return result;
    }, source);
  };
  for (var _i2 = 0, _args = args; _i2 < _args.length; _i2++) {
    var _ret = _loop();
    if (_ret === "continue") continue;
  }
  return source;
};

/**
 * @constant {RegExp} 判断是否符合 camelcase 的正则
 */
var CAMELCASE_PATTERN = /^[a-z]+([A-Z]+[a-z\d]*)+$/;

/**
 * 将 camelcase 字符转为 underscore 风格
 *
 * @param {string} input 待转换的字符串
 * @return {string} 转换为 underscore 风格的字符
 */
var toUnderScore = function toUnderScore(input) {
  return String(input).replace(/[A-Z]+/g, function (chr) {
    return "_".concat(chr.toLowerCase() + (chr.length > 1 ? '_' : ''));
  }).replace(/_$/, '');
};

/**
 * 转换 json 中 key 为 camelcase 风格的项
 *
 * @param {string} key  待转换的键
 * @param {Object} json 待转换的对象
 */
function transform(key, json) {
  var newKey = toUnderScore(key);
  if ((!(newKey in json) || json[newKey] == null) && json[key] != null) {
    json[newKey] = isObject(json[key]) ? extend({}, json[newKey], camelToUnder(json[key])) : json[key];
  }
  if (key in json) {
    delete json[key];
  }
}

/**
 * 转换对象中 key 为 camelcase 的为 underscore 风格
 *
 * @function
 * @param {Object} json 待转换的对象
 * @param {?Array.<string>=} backlist 要转换的名单
 * @return {Object} 转换后的 json 对象
 */
export function camelToUnder() {
  var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var backlist = arguments.length > 1 ? arguments[1] : undefined;
  var keys = backlist && backlist.length ? backlist : Object.keys(json);
  keys.filter(function (key) {
    return CAMELCASE_PATTERN.test(key);
  }).forEach(function (key) {
    return transform(key, json);
  });
  return json;
}